import styled from 'styled-components';
import {Typography} from 'epic-ue-ui';

export const StyledTypography = styled(Typography)<{
    fontSize?: number;
    lineHeight?: number;
    letterSpacing?: number;
    fontWeight?: number;
    customColor?: string;
    textAlign?: string;
}>`
    font-family: 'Inter';
    text-align: ${p => p.textAlign ?? 'left'};
    font-size: ${p => p.fontSize ?? 16}px;
    font-weight: ${p => p.fontWeight ?? 400};
    line-height: ${p => p.lineHeight ?? 20}px;
    letter-spacing: ${p => p.letterSpacing ?? 0.2}px;
    color: ${p => p.customColor ?? '#E6E6EA'};
`;
